import React from 'react';
import classnames from 'classnames';
import { string, number, bool } from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { b_select_crown } from '@fiverr-private/icons';
import { getContext } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { getSellerClass } from '../../../helpers';

import './style.scss';

const getUrl = (shouldDisplayVid) => (
    shouldDisplayVid
        ? pathfinder('static_page', { page_name: 'vid-program' })
        : pathfinder('levels')
);

const UserBadge = ({ size, achievement, isVid }) => {
    const { locale } = getContext();
    const shouldDisplayVid = isVid && !achievement;

    const classNames = classnames(
        'user-badge-round',
        size,
        `locale-${locale.toLowerCase()}`,
        getSellerClass(achievement),
        { 'select-user': shouldDisplayVid }
    );

    const url = getUrl(shouldDisplayVid);

    if (shouldDisplayVid) {
        return (
            <a href={pathfinder('select')} rel="nofollow" className={classNames}>
                <span className="vid-icon">
                    <Icon className="crown-icon">{b_select_crown}</Icon>
                </span>
            </a>
        );
    }

    return (
        <a href={url} rel="nofollow" className={classNames}/>
    );
};

UserBadge.propTypes = {
    size: string,
    achievement: number,
    isVid: bool
};

export default UserBadge;
